<template>
    <main
        v-if="terms"
        class="m-terms"
    >
        <y-hero
            :title="terms.title"
            :synopsis="terms.synopsis"
        />

        <y-container>
            <div
                class="m-terms__content"
                v-html="terms.text"
            />
        </y-container>

        <y-container>
            <y-contact-banner :items="terms.custom" />
        </y-container>
    </main>
</template>

<script>
    // Mixins
    import PageMixin from '@groot-nodes/mixins/Page.js';

    // Helper
    import { removeSymbol } from '@/helpers/helpers';

    // Components
    import YHero from '../components/hero/index.vue';
    import YContactBanner from '../components/ContactBanner/ContactBanner.vue';

    export default {
        name: 'TermsOfUse',

        components: {
            YHero,
            YContactBanner,
        },

        mixins: [PageMixin],

        /**
         * @inheritdoc
         */
        data() {
            return {
                terms: '',
            };
        },

        /**
         *
         * @inheritDoc
         */
        metaInfo() {
            return {
                title: this.terms.seo_post_title,

                meta: [
                    {
                        vmid   : 'description',
                        name   : 'description',
                        content: this.terms.seo_meta_description,
                    },
                ],
            };
        },

        methods: {
            removeSymbol,

            /**
             * Fetch form config
             * 
             * @returns {*}
             */
            fetch() {
                const terms = this.$services.Content.postSingle({
                    type     : 'landing-page',
                    slug     : 'terms-of-use',
                    including: ['synopsis', 'title', 'text', 'custom', 'seo_canonical', 'seo_meta_description', 'seo_post_title'],
                    locale   : this.$i18n.locale,
                }).catch((error) => {
                    this.handleError(error);
                });

                return Promise.all([terms]).then((responses) => {
                    if (this.handleReq(responses, 0)) {
                        this.terms = responses[0].data.results;
                    }
                }).catch((error) => {
                    this.handleError(error);
                });
            },
        },
    };

</script>

<style lang="scss" src="../scss/terms-of-use.scss" />
